import { render, staticRenderFns } from "./courseCompany.vue?vue&type=template&id=7b64c24f&scoped=true&"
import script from "./courseCompany.vue?vue&type=script&lang=js&"
export * from "./courseCompany.vue?vue&type=script&lang=js&"
import style0 from "./courseCompany.vue?vue&type=style&index=0&id=7b64c24f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b64c24f",
  null
  
)

export default component.exports